<template>
  <v-btn
    color="blue lighten-5"
    class="elevation-0 inline-action-btn"
    @click="$emit('onClickAction')"
  >
    <v-icon small>{{ icon }}</v-icon>
    {{ text }}
  </v-btn>
</template>

<script>
export default {
  name: 'InlineActionBtn',
  props: ['text', 'icon']
}
</script>

<style scoped lang="scss">
.inline-action-btn {
  margin: 0 5px;
  height: max-content;
  border-radius: 8px;
  color: $blue-primary;
}
</style>



// WEBPACK FOOTER //
// src/components/parts/utils/buttons/InlineActionBtn.vue